import { call, put, takeLeading } from 'redux-saga/effects';
import { showNotification, refreshView } from 'react-admin';
import { AllocatePayload } from './types';
import {
  allocateUserSelfApply,
  getProviders,
} from './api';
import {
  USER_SELF_APPLY_ALLOCATE,
  allocateUserSelfApplyRequest,
  allocateUserSelfApplySuccess,
  allocateUserSelfApplyFailure,
  USER_SELF_APPLY_PROVIDERS_REQUEST,
  fetchProvidersSuccess,
  fetchProvidersFailure,
} from './actions';

function* allocateSaga(): any {
  yield takeLeading(USER_SELF_APPLY_ALLOCATE, function* ({ payload }: { type: string; payload: AllocatePayload }) {
    yield put(allocateUserSelfApplyRequest());
    try {
      yield call(allocateUserSelfApply, payload);
      yield put(allocateUserSelfApplySuccess());
      yield put(showNotification('Allocated successfully'));
      yield put(refreshView());
    } catch (err) {
      yield put(allocateUserSelfApplyFailure(err));
      yield put(showNotification(`${err}`, 'error'));
    }
  });
}

function* providersSaga(): any {
  yield takeLeading(USER_SELF_APPLY_PROVIDERS_REQUEST, function* (): any {
    try {
      const providers = yield call(getProviders);
      yield put(fetchProvidersSuccess(providers));
    } catch (err) {
      yield put(fetchProvidersFailure(err));
    }
  });
}

export const userSelfApplySagas = [
  allocateSaga,
  providersSaga,
];
